import HomeIcon from '@mui/icons-material/AppsRounded';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Stack } from '@mui/material';
import List from '@mui/material/List';
import { SSO_REDIRECT_TO_ADDRESS } from 'config';
import useFeatureFlag from 'hooks/useFeatureFlag';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getInfoByDomain } from 'utils/domainUtils';
import { isExternalUser } from 'utils/userRolesHelper';
import { getAvailableRoutes } from '../navigationRoutes';
import DrawerItem from './DrawerItem';
import { CustomDivider, GroupHeader } from './DrawerStyled';

const homeButtonClickHandler = () => window.location.assign(SSO_REDIRECT_TO_ADDRESS);

const DrawerListItem = ({ user, toggleDrawer, features }) => {
    const location = useLocation();
    const [openSections, setOpenSections] = useState({});
    const featureFlag = useFeatureFlag();
    const toggleSection = (key) => {
        setOpenSections((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    const routes = getAvailableRoutes(featureFlag, user);

    const isRouteAllowed = (route) => {
        const userRoles = user.roles;
        const allowedRoles = route?.allowedRoles || [];
        // If no roles are defined, it's allowed by default
        if (!allowedRoles.length) return true;
        return userRoles.some((role) => allowedRoles.includes(role));
    };
    const { logo, text } = getInfoByDomain();

    return (
        <List sx={{ padding: 0 }}>
            <DrawerItem
                route={{
                    path: '',
                    text,
                    Icon: logo,
                }}
                isHeader={true}
            />

            {!isExternalUser(user) && (
                <>
                    <CustomDivider />
                    <DrawerItem
                        route={{
                            text: 'All services',
                            Icon: HomeIcon,
                        }}
                        onClick={homeButtonClickHandler}
                    />
                </>
            )}
            {/* Render route has sub item */}
            {routes.map((group, groupIndex) => (
                <React.Fragment key={groupIndex}>
                    <CustomDivider />
                    <GroupHeader>{group.section}</GroupHeader>
                    {group?.items?.map((route) => {
                        const canAccessRoute = isRouteAllowed(route) || route.permissionChecker?.(user, features);
                        if (!canAccessRoute) return null;

                        const isChildActive = route.items?.some((item) => location.pathname.startsWith(item.path));
                        const isOpen = openSections[route.text] || isChildActive;

                        if (route.items) {
                            return (
                                <>
                                    <DrawerItem
                                        key={route.path}
                                        route={route}
                                        onClick={() => toggleSection(route.text)}
                                        endIcon={isOpen ? <ExpandLess /> : <ExpandMore />}
                                    />
                                    {isOpen &&
                                        route.items.map((item) => {
                                            const canAccessItem = isRouteAllowed(item) || item.permissionChecker?.(user, features);
                                            if (!canAccessItem) return null;
                                            return (
                                                <Stack key={item.path} paddingLeft={3}>
                                                    <DrawerItem key={item.path} route={item} onClick={toggleDrawer} />
                                                </Stack>
                                            );
                                        })}
                                </>
                            );
                        }

                        return <DrawerItem key={route.path} route={route} onClick={toggleDrawer} />;
                    })}
                </React.Fragment>
            ))}
        </List>
    );
};

export default DrawerListItem;

DrawerListItem.propTypes = {
    user: PropTypes.object,
    toggleDrawer: PropTypes.func,
    features: PropTypes.array,
};
